/**
 * Детализация.
 * @return Promise
 */
const getDetailList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/detailing/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Получение количества смс
 */
const getSMSCount = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/detailing/getCount",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { getDetailList, getSMSCount };
